import { api } from "@/client/api"

export default {
    apply(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/apply`, request)
    },

    acceptOffer(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/acceptOffer`, request)
    },

    addBankCard(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/bank-card`, request)
    },

    addBankAccount(providerKey, request) {
        return api.post(`providers/${encodeURIComponent(providerKey)}/application/bank-account`, request)
    },

    completeApplication(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/complete`)
    },

    confirmPaymentPlan(providerKey, request) {
        return api.post(
            `/providers/${encodeURIComponent(providerKey)}/payment/plans/${encodeURIComponent(request.providerPlanCode)}/confirm-selection`,
            request
        )
    },

    esignApplication(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/esign`)
    },

    getDisclosures(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/disclosures`)
    },

    getDisclosuresHtml(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/disclosures-html`)
    },

    getLoanAgreementHtml(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/agreement`)
    },

    getPaymentPlans(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/payment/plans`, request)
    },

    getStipulationStatus(providerKey, stipulationId) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/application/stipulations/${stipulationId}/status`)
    },

    getDocuments(providerKey, types) {
        let url = `/providers/${encodeURIComponent(providerKey)}/application/documents`
        if (types) {
            url += "?types=" + encodeURIComponent(types)
        }
        return api.get(url)
    },

    patch(providerKey, request, applyMode) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/patch/${applyMode}`, request)
    },

    prequalify(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/prequalify`, request)
    },

    prescreen(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/prescreen`, request)
    },

    publishPaymentPlansPresented(providerKeys) {
        if (!Array.isArray(providerKeys)) {
            providerKeys = [providerKeys]
        }

        return api.post(`/application/events/financing-plans-presented`, { providerKeys })
    },

    refreshStipulations(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/stipulations/refresh`, request)
    },

    sendAnswers(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/answers`, request)
    },

    startProvider(providerKey, applyMode) {
        let url = "/apply/start/providers/" + encodeURIComponent(providerKey)

        if (applyMode) {
            url += "?mode=" + encodeURIComponent(applyMode)
        }

        return api.post(url)
    },

    /**
     * @param {string} providerKey
     * @param {string} [redirectUrl]
     * @returns {Promise<import("@/model/provider/IframeResponse.ts").IframeResponse | undefined>}
     */
    getIframeUrl(providerKey, redirectUrl) {
        if (redirectUrl) {
            return api.get(
                `/providers/${encodeURIComponent(providerKey)}/iframeUrl?redirectUrl=${encodeURIComponent(redirectUrl)}`
            )
        } else {
            return api.get(`/providers/${encodeURIComponent(providerKey)}/iframeUrl`)
        }
    },

    sdkConfig(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/sdkConfig`)
    },

    selectPaymentPlan(providerKey, request) {
        return api.post(
            `/providers/${encodeURIComponent(providerKey)}/payment/plans/${encodeURIComponent(request.providerPlanCode)}/select`,
            request
        )
    },

    updatePaymentMethod(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/paymentMethod`, request)
    },

    // *** Service Call Graveyard **

    getApplicationStatus(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application-status`)
    },

    emailAgreement(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/emailAgreement`, request)
    },

    getAccountTerms(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/account/terms`)
    },

    getQuiz(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/quiz`)
    },

    getIframeUrlWithRedirectUrl(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/iframeUrl`, request)
    },
}
